import {ActionCreatorDefinition, createAction} from "redux-ts";
import {TradeSymbol} from "platform/protocol/trading/symbol/TradeSymbol";
import {SymbolSubscriptionInfo} from "protocol/symbol/SymbolSubscriptionInfo";
import {TSMap} from "typescript-map";
import {TradeColumn} from "enum/TradeColumn";
import {CategoryCounterState, SymbolSelection, SymbolTableState} from "core/redux/symbols/SymbolReduxState";
import {SortDirection} from "platform/enum/SortDirection";
import {Quote} from "platform/protocol/trading/Quote";

export const SetSymbolTablesLSType: string = "SetSymbolTablesLS";
export const SetSymbolsType: string = "SetSymbols";
export const FailedFetchSymbolsType: string = "FailedFetchSymbols";
export const SetTopSymbolsType: string = "SetTopSymbols";
export const SetSubscribedSymbolsType: string = "SetSubscribedSymbols";
export const SubscribeSymbolType: string = "SubscribeSymbol";
export const UnSubscribeSymbolType: string = "UnSubscribeSymbol";
export const AddSubscribedSymbolType: string = "AddSubscribedSymbol";
export const RemoveSubscribedSymbolType: string = "RemoveSubscribedSymbol";
export const SetSymbolTabType: string = "SetSymbolTab";
export const SetSymbolTradeColumnType: string = "SetSymbolTradeColumn";
export const ToggleSymbolColumnSortType: string = "ToggleSymbolColumnSort";
export const SetSortedSymbolsType: string = "SetSortedSymbols";
export const SetSymbolFilterCounterType: string = "SetSymbolFilterCounter";
export const SelectSymbolType: string = "SelectSymbol";

export interface SetSymbolTablesLSPayload {

    tables: TSMap<string, SymbolTableState>;
}

export interface SetSymbolsPayload {

    symbols: TSMap<number, TradeSymbol>;
    overview: TradeSymbol[];
    categories: TSMap<string, TradeSymbol[]>;
    counters: TSMap<string, CategoryCounterState>;
    selectedSymbols: TSMap<string, SymbolSelection>;
    tables: TSMap<string, SymbolTableState>;
}

export interface SetTopSymbolsPayload {

    symbols: TradeSymbol[];
}

export interface SetSubscribedSymbolsPayload {

    symbols: TSMap<number, SymbolSubscriptionInfo>;
}

export interface SymbolPayload {

    symbol: TradeSymbol;
}

export interface AddSubscribedSymbolPayload extends SymbolPayload {

    quotes: TSMap<number, Quote>;
}

export interface SetSymbolTabPayload {

    category: string;
}

export interface SetSymbolTradeColumnPayload {

    tradeColumn: TradeColumn;
    category: string;
}

export interface ToggleSymbolColumnSortPayload {

    tradeColumn: TradeColumn;
    category: string;
}

export interface SetSortedSymbolsPayload {

    symbols: TradeSymbol[];
    category: string;
    tradeColumn: TradeColumn;
    sortDirection: SortDirection;
}

export interface SetSymbolFilterCounterPayload {

    value: number;
    category: string;
}

export interface SelectSymbolPayload {

    symbol: TradeSymbol;
}

export const SetSymbolTablesLS: ActionCreatorDefinition<SetSymbolTablesLSPayload, any> = createAction<SetSymbolTablesLSPayload>(SetSymbolTablesLSType);
export const SetSymbols: ActionCreatorDefinition<SetSymbolsPayload, any> = createAction<SetSymbolsPayload>(SetSymbolsType);
export const FailedFetchSymbols: ActionCreatorDefinition<any, any> = createAction<any>(FailedFetchSymbolsType);
export const SetTopSymbols: ActionCreatorDefinition<SetTopSymbolsPayload, any> = createAction<SetTopSymbolsPayload>(SetTopSymbolsType);
export const SetSubscribedSymbols: ActionCreatorDefinition<SetSubscribedSymbolsPayload, any> = createAction<SetSubscribedSymbolsPayload>(SetSubscribedSymbolsType);
export const SubscribeSymbol: ActionCreatorDefinition<SymbolPayload, any> = createAction<SymbolPayload>(SubscribeSymbolType);
export const UnSubscribeSymbol: ActionCreatorDefinition<SymbolPayload, any> = createAction<SymbolPayload>(UnSubscribeSymbolType);
export const AddSubscribedSymbol: ActionCreatorDefinition<AddSubscribedSymbolPayload, any> = createAction<AddSubscribedSymbolPayload>(AddSubscribedSymbolType);
export const RemoveSubscribedSymbol: ActionCreatorDefinition<SymbolPayload, any> = createAction<SymbolPayload>(RemoveSubscribedSymbolType);
export const SetSymbolTab: ActionCreatorDefinition<SetSymbolTabPayload, any> = createAction<SetSymbolTabPayload>(SetSymbolTabType);
export const SetSymbolTradeColumn: ActionCreatorDefinition<SetSymbolTradeColumnPayload, any> = createAction<SetSymbolTradeColumnPayload>(SetSymbolTradeColumnType);
export const ToggleSymbolColumnSort: ActionCreatorDefinition<ToggleSymbolColumnSortPayload, any> = createAction<ToggleSymbolColumnSortPayload>(ToggleSymbolColumnSortType);
export const SetSortedSymbols: ActionCreatorDefinition<SetSortedSymbolsPayload, any> = createAction<SetSortedSymbolsPayload>(SetSortedSymbolsType);
export const SetSymbolFilterCounter: ActionCreatorDefinition<SetSymbolFilterCounterPayload, any> = createAction<SetSymbolFilterCounterPayload>(SetSymbolFilterCounterType);
export const SelectSymbol: ActionCreatorDefinition<SelectSymbolPayload, any> = createAction<SelectSymbolPayload>(SelectSymbolType);
